export default __webpack_public_path__ + "5fde453ebe482c07c5266de24d083b6f.png";